module.exports = __webpack_public_path__ + "media/customizations/bedfordlife/logo-a253cf66c3cbc88503f83664fb608f41.png";